module.exports = __webpack_public_path__ + "static/map-pixel-2f891b9a5fb3a069e84f34495af55727.jpg";